namespace $ {

	export class $mynamespace_myapp_profile extends $giper_baza_entity.with({
		Name: $giper_baza_atom_text,
		Email: $giper_baza_atom_text,
	}) {}

}
